import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import { useRouter }												from 'vue-router';

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import messages from '@/utils/messages'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnSaveFocusedInstitutional',
  props: {
    accordionRef: {}
  },
  setup(__props: any) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()

const props = __props;

/**
 * ✅ REGRA DE EXIBIÇÃO (SALVAR RASCUNHO)
 */

const showSaveButton = computed(() => {
  const detail = institutionalStore.institutionalDetail;
  const status = detail?.status;

  // ✅ NOVO: fluxo de criação (review antes de salvar)
  if (!detail) {
    return authStore.currentUserCanCreateInstitutional;
  }

  // ✅ fluxo normal
  return (
    authStore.currentUserCanCreateInstitutional &&
    !institutionalStore.institutionalDetail?.cadastroEditado &&
    (
      !status ||
      status === CONST_INSTITUTIONAL_STATUS.DRAFT.id ||
      status === CONST_INSTITUTIONAL_STATUS.ON_EDITING.id
    )
  );
});

const uploadImagens = async (imagensDraft: any[]) => {
  if (!imagensDraft.length) {
    throw new Error('Nenhuma imagem para upload');
  }

  const formData = new FormData();
  const posicoes: number[] = [];

  imagensDraft.forEach(img => {
    if (img.file) {
      formData.append('images', img.file);
      posicoes.push(img.posicaoImagem);
    }
  });

  const response = await fetch('http://localhost:3000/uploadTelasATMImages', {
    method: 'POST',
    body: formData
  });

  const resultado = await response.json();

  if (!resultado.success) {
    throw new Error(resultado.error || 'Erro ao fazer upload');
  }

  // ✅ montar payload final igual backend espera
  return resultado.uploadLocations.map((item: any, index: number) => ({
    posicaoImagem: posicoes[index],
    urlS3: item.url,
    duracaoImagem: 5
  }));
};

// const onSaveInstitutional = async () => {
//   try {
//     pagesUtilStore.showLoading = true

//     // ✅ imagens
//     const imagensDraft = props.accordionRef?.getImagensSemUpload?.()?.length
//       ? props.accordionRef.getImagensSemUpload()
//       : institutionalStore.imagensDraft

//     const imagensComPosicao = imagensDraft.length
//       ? await institutionalStore.uploadImagens(imagensDraft)
//       : []

//     // ✅ telas
//     const telas =
//       props.accordionRef?.getTelasSeleccionadas?.() ||
//       institutionalStore.telasDraft

//     // ✅ flag abertura
//     const exibeTelaAbertura =
//       props.accordionRef?.getExibeTelaAbertura?.() ??
//       institutionalStore.exibeTelaAberturaRascunho

//     // ✅ 🔥 SNAPSHOT DA COR (UMA ÚNICA VEZ)
//     const corTextoSnapshot = props.accordionRef?.value?.getCorTexto?.() ?? null

//     console.log('✅ SNAPSHOT corTexto antes do save:', corTextoSnapshot)

//     // ✅ SALVA UMA ÚNICA VEZ
//     const id = await institutionalStore.createInstitutional(
//       imagensComPosicao,
//       telas,
//       exibeTelaAbertura,
//       corTextoSnapshot,
//       true // rascunho
//     )

//     if (!id) return

//     messages.showSuccessMsg('Cadastro salvo com sucesso.')

//     // ✅ SÓ NAVEGA DEPOIS DE SALVAR
//     router.push({
//       name: EnumRouteNames.INSTITUTIONAL_VIEW,
//       params: { id }
//     })

//   } catch (error: any) {
//     console.error(error)
//     messages.showErrorMsg(error?.message || 'Erro ao salvar cadastro.')
//   } finally {
//     pagesUtilStore.showLoading = false
//   }
// }

const onSaveInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const accordion = props.accordionRef?.value

    // ✅ imagens
    const imagensDraft = accordion?.getImagensSemUpload?.()?.length
      ? accordion.getImagensSemUpload()
      : institutionalStore.imagensDraft

    const imagensComPosicao = imagensDraft.length
      ? await institutionalStore.uploadImagens(imagensDraft)
      : []


 let telasSelecionadas = props.accordionRef?.getTelasSelecionadas()

if (!telasSelecionadas || telasSelecionadas.length === 0) {
  const imagens = institutionalStore.imagensDraft

  const temInicial = imagens.some(img =>
    [1, 2, 3, 4, 8, 9, 10, 11].includes(img.posicaoImagem)
  )

  const temAguarde = imagens.some(img =>
    [6, 7].includes(img.posicaoImagem)
  )

  telasSelecionadas = []
telasSelecionadas.push({ tipoTela: 'ABERTURA' })
  if (temInicial) {
    telasSelecionadas.push({ tipoTela: 'INICIAL' })
  }

  if (temAguarde) {
    telasSelecionadas.push({ tipoTela: 'AGUARDE' })
  }


}
    // ✅ telas
    const telas =
      accordion?.getTelasSelecionadas?.() ||
      institutionalStore.telasDraft


    // ✅ flag abertura
    const exibeTelaAbertura =
      accordion?.getExibeTelaAbertura?.() ??
      institutionalStore.exibeTelaAberturaRascunho

    // ✅ 🔥 SNAPSHOT DA COR
    const corTextoSnapshot = accordion?.getCorTexto?.() ?? null

    console.log('✅ SNAPSHOT corTexto antes do save:', corTextoSnapshot)

    const id = await institutionalStore.createInstitutional(
      imagensComPosicao,
      telasSelecionadas,
      exibeTelaAbertura,
      corTextoSnapshot,
      true
    )

    if (!id) return

    messages.showSuccessMsg('Cadastro salvo com sucesso.')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })

  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(error?.message || 'Erro ao salvar cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}




return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (showSaveButton.value)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-save-institutional",
        propBtnLabel: "Salvar",
        propBtnFunction: onSaveInstitutional,
        propBtnTransparent: true,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})